const STORAGE_KEY = 'thredz_mock_coupons'

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch (e) {
    console.error('Failed to load coupons', e)
    return []
  }
}

function save(list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
  } catch (e) {
    console.error('Failed to save coupons', e)
  }
}

function generateId() {
  return `CPN-${Date.now().toString(36)}-${Math.floor(Math.random() * 1000)}`
}

export async function getCoupons() {
  // simulate delay
  await new Promise(r => setTimeout(r, 200))
  return load()
}

export async function createCoupon(data) {
  await new Promise(r => setTimeout(r, 300))
  const list = load()
  const exists = list.find(c => c.code === data.code)
  if (exists) {
    const err = new Error('Coupon code already exists')
    err.code = 'DUPLICATE'
    throw err
  }

  const coupon = {
    id: generateId(),
    code: data.code,
    minOrderValue: Number(data.minOrderValue) || 0,
    maxOrderValue: data.maxOrderValue ? Number(data.maxOrderValue) : null,
    discountType: data.discountType || 'percent', // 'percent' or 'amount'
    discountValue: Number(data.discountValue) || 0,
    expiry: data.expiry || null,
    description: data.description || '',
    uses: Number(data.uses) || 0,
    // maximum number of times this coupon can be used; null => unlimited
    maxUses: (typeof data.maxUses !== 'undefined' && data.maxUses !== null) ? Number(data.maxUses) : null,
    enabled: true,
    createdAt: new Date().toISOString(),
  }

  list.unshift(coupon)
  save(list)
  return coupon
}

export async function clearCoupons() {
  save([])
}

export async function toggleCoupon(id, enabled) {
  await new Promise(r => setTimeout(r, 150))
  const list = load()
  const idx = list.findIndex(c => c.id === id)
  if (idx === -1) throw new Error('Coupon not found')
  list[idx] = { ...list[idx], enabled: !!enabled }
  save(list)
  return list[idx]
}

export async function incrementCouponUsage(id) {
  await new Promise(r => setTimeout(r, 150))
  const list = load()
  const idx = list.findIndex(c => c.id === id)
  if (idx === -1) throw new Error('Coupon not found')
  const current = list[idx].uses || 0
  const max = typeof list[idx].maxUses !== 'undefined' ? list[idx].maxUses : null
  if (max !== null && current >= max) {
    const err = new Error('Max uses reached')
    err.code = 'MAX_REACHED'
    throw err
  }
  list[idx] = { ...list[idx], uses: current + 1 }
  save(list)
  return list[idx]
}

export async function deleteCoupon(id) {
  await new Promise(r => setTimeout(r, 150))
  const list = load()
  const idx = list.findIndex(c => c.id === id)
  if (idx === -1) throw new Error('Coupon not found')
  list.splice(idx, 1)
  save(list)
  return true
}

export default { getCoupons, createCoupon, clearCoupons }
